export const TYPES = {
  SET_TOGGLE_MODAL_OPEN: "SET_TOGGLE_MODAL_OPEN",
  SET_FIELD_IS_FICTIOUS: "SET_FIELD_IS_FICTIOUS",
  SET_FIELD: "SET_FIELD",
  SET_CLEAR_FORM_DATA: "SET_CLEAR_FORM_DATA",
  SET_CLEAR_FIELD_AND_CLEAR_CHILDREN: "SET_CLEAR_FIELD_AND_CLEAR_CHILDREN",
  SET_REQUESTED_LOCALITIES_DATA: "SET_REQUESTED_LOCALITIES_DATA",
  SET_LAST_FORM: "SET_LAST_FORM",
  SET_LAST_CREATION: "SET_LAST_CREATION",
};
